export default "__VITE_ASSET__BszNrHvq__"